/**
 * Data Type
 */
export interface InfoParcelas {
  numberOfInstallments: number
  requestedAmount: number
  installmentAmount: number
  availableAmount: number
  amountIOF: number
  percentageIOF: number
  financedAmount: number
  cETAm: number
  cETAa: number
  monthlyNominalRate: number
  yearlyNominalRate: number
  contractualInterest: number
  lastDueDate: string
  firstDueDate: string
  moneyChange: number
  insuranceFee: number
  contractedInterestPercentage: number
  totalValueToBePaid: number
  txIRAm: number
  txIRAa: number
  insuranceValuePercentage: number
}

export interface Recalculo {
  debtBalance: string
  availableAmount: string
  requestedAmount: string
  valorProximaParcela: string
}

/**
 * Actions Types
 */

export enum SimulacaoTypes {
  SIMULACAO_REQUEST = '@refinanciamento/simulacao/SIMULACAO_REQUEST',
  SIMULACAO_SUCCESS = '@refinanciamento/simulacao/SIMULACAO_SUCCESS',
  SIMULACAO_ERROR = '@refinanciamento/simulacao/SIMULACAO_ERROR',
  SET_PARCELA_SELECIONADA = '@refinanciamento/simulacao/SET_PARCELA_SELECIONADA',
  SET_SALDO_DEVEDOR = '@refinanciamento/simulacao/SET_SALDO_DEVEDOR',
  SET_TOTAL_PARCELAS = '@refinanciamento/simulacao/SET_TOTAL_PARCELAS',
  TRACKING_REFIN = '@refinanciamento/simulacao/TRACKING_REFIN',
  SELECT_SIMULACAO = '@refinanciamento/simulacao/SELECT_SIMULACAO',
  SET_SIMULACAO_ID = '@refinanciamento/simulacao/SET_SIMULACAO_ID',
  GET_SIMULACAO_ID = '@refinanciamento/simulacao/GET_SIMULACAO_ID',
  SET_SIMULACAO_RECALCULO = '@refinanciamento/simulacao/SET_SIMULACAO_RECALCULO',
  GET_SIMULACAO_RECALCULO = '@refinanciamento/simulacao/GET_SIMULACAO_RECALCULO',
  LOADING_SIMULACAO_ID = '@refinanciamento/simulacao/LOADING_SIMULACAO_ID',
  CLEAR_SIMULACAO = '@refinanciamento/simulacao/CLEAR_SIMULACAO',
  SET_DADOS_SIMULACAO_ALTERADOS = '@refinanciamento/simulacao/SET_DADOS_SIMULACAO_ALTERADOS',
  SET_BOTTOMSHEET_ORIGIN = '@refinanciamento/simulacao/SET_BOTTOMSHEET_ORIGIN',
  SET_SOLICITAR_CONTRATACAO_ORIGIN = '@refinanciamento/simulacao/SET_SOLICITAR_CONTRATACAO_ORIGIN',
}
/**
 * State Type
 */

export interface SimulacaoState {
  readonly parcelaAtual: InfoParcelas
  readonly simulations: InfoParcelas[]
  readonly simulationsWithInsurance: InfoParcelas[]
  readonly debtBalance: number
  readonly totalParcelas: number
  readonly loadingSimulacao?: boolean
  readonly errorSimulacao?: boolean
  readonly simulacaoSelecionada: 'simulations' | 'simulationsWithInsurance'
  readonly simulacaoId: number
  readonly loadingGetSimulacao: boolean
  readonly dadosSimulacaoAlterados: boolean
  readonly bottomsheetOrigin?: boolean
  readonly solicitarContratacaoOrigin?: boolean
}

export type pendencyType =
  | 'PENDENCIA_IRREVERSIVEL'
  | 'PENDENCIA_REVERSIVEL_LEAD_NOVO'
  | 'PENDENCIA_TEIMOSINHA'
  | 'PENDENCIA_VALIDACAO'
  | 'CS005'
  | 'CS006'
  | ''

/**
 * Actions Payload Types
 */
export interface CallbackSimulacaoType {
  pending?: pendencyType
  simulations: InfoParcelas[]
  simulationsWithInsurance: InfoParcelas[]
}

export type SimulacaoRequestPayload = {
  erroCallback: () => void
  callback: (params: CallbackSimulacaoType) => void
}

export type SimulacaoIdPayload = {
  callback: () => void
}
